import secretQuestionsMessageDescriptors from "./secret-questions-message-descriptors";

const findMessageForCode = code => secretQuestionsMessageDescriptors[code];

/**
 * Maps secret question codes to translation messages
 * @param {array} secretQuestions - Array of secret questions as returned from PUAMiddle
 * @returns {array} Array of objects containing mapped translation messages and matching codes as values
 */
const mapCodesToOptions = (secretQuestions = []) =>
  secretQuestions.reduce((accumulator, { code, question }) => {
    const mappedMessage = findMessageForCode(code);

    if (mappedMessage) {
      accumulator.push({
        id: code,
        value: code,
        question,
        message: mappedMessage
      });
    }

    return accumulator;
  }, []);

export { findMessageForCode };
export default mapCodesToOptions;
